import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconFileExcelColor from './icon-file-excel-color.vue';

const IconFileExcelColor = Object.assign(_IconFileExcelColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconFileExcelColor.name, _IconFileExcelColor);
  }
});

export default IconFileExcelColor;
